import { getConfig } from '../../../config';

export const AuthConstants = {
    Debug: true,
    API_BASE: (await getConfig()).RDARR_APP_URL + '/api', // RDARR API
    MeEndpoint: '/auth/me',
    RefreshEndpoint: '/auth/refresh',
    RelayExchangeEndpoint: '/auth/relay-exchange',

    // Host portal endpoint to mint a relay-token for RDARR
    HostRelayEndpoint: '/api/relay/token?app=rdarr', // hits host origin
    LoginEndpoint: '/Login', // host login
};
